module.exports = __webpack_public_path__ + "static/media/t33.a65f9fef.jpg";